import Bimface from "./components/bimface.vue";
import Model from "./components/model.vue";
import ModelComponent from "./components/model-component.js";
// Anchor
import PrismPoint from "./components/Anchor/prism-point.vue";
// Drawable
import CustomItem from "./components/Drawable/custom-item.vue";
// Material
import Material from "./components/material";
// Animation
import FlowEffect from "./components/Animation/flow-effect";
// 外部构件
import ExternalObject from "./components/external-object.vue";
// 剖切
import SectionRegion from "./components/Section/section-region";

export { Bimface, Model, ModelComponent, PrismPoint };

export default {
  install: function (Vue, options) {
    let defaultGetViewTokenApi = async () => {
      return Promise.reject(`请在options中配置getViewTokenApi方法`);
    };
    let BimfaceMethods = Bimface.methods;
    BimfaceMethods.getViewTokenApi =
      options?.getViewTokenApi || defaultGetViewTokenApi;
    let ModelMethods = Model.methods;
    ModelMethods.getViewTokenApi =
      options?.getViewTokenApi || defaultGetViewTokenApi;
    Vue.component(Bimface.name, { ...Bimface, methods: { ...BimfaceMethods } });
    Vue.component(Model.name, { ...Model, methods: { ...ModelMethods } });
    Vue.component(ModelComponent.name, ModelComponent);
    Vue.component(PrismPoint.name, PrismPoint);
    Vue.component(CustomItem.name, CustomItem);
    Vue.component(Material.name, Material);
    Vue.component(FlowEffect.name, FlowEffect);
    Vue.component(ExternalObject.name, ExternalObject);
    Vue.component(SectionRegion.name, SectionRegion);
  },
};
